module.exports = __webpack_public_path__ + "static/tvGoogleAssistant-f00b04900bbf97cd318c1996f19bd0f4.png";